// Event Tracking
function analyticsEvent($event = 'event', $category = 'click', $action = false, $label = false, $parameters = {}) {
    window.dataLayer = window.dataLayer || [];
    if (typeof window.dataLayer === 'object') {

        var $push = {};
        if ($event) {
            $push = {...$push, 'event': $event};
        }
        if ($category) {
            $push = {...$push, 'event_category': $category};
        }
        if ($action) {
            $push = {...$push, 'event_action': $action};
        }
        if ($label) {
            $push = {...$push, 'event_label': $label};
        }

        var $layer = {...$push, ...$parameters}
        window.dataLayer.push($layer);
    }
}

window.analyticsEvent = analyticsEvent;
